<template>
  <div class="flex">
    <div class="branca">
      <v-container>
        <v-row class="mb-6" no-gutters>
          <v-col cols="6">
            <img width="230" src="@/assets/img/dcomp.png" alt="" />
          </v-col>

          <v-col cols="6">
            <img width="250" src="@/assets/img/logo_UFS.png" alt="" />
          </v-col>
        </v-row>
      </v-container>
      <div class="div-esq">
        <v-sheet width="400" class="mx-auto">
          <h1 class="poppins400">Entrar</h1>
          <br />
          <div class="justify-content">
            <h4 class="poppins400">Se possui um convite de projeto</h4>
            <h4 class="poppins400">
              Você pode inseri-lo
              <router-link to="/validacao" style="text-decoration: none"
                >aqui</router-link
              >
            </h4>
            <br />
          </div>

          <v-form @submit.prevent="login()">
            <v-text-field
              v-model="email"
              required
              :rules="rules"
              variant="underlined"
              label="Insira seu email"
              prepend-inner-icon="mdi-email-outline"
            >
            </v-text-field
            ><br />

            <v-text-field
              v-model="password"
              label="Insira sua senha"
              variant="underlined"
              prepend-inner-icon="mdi-lock-outline"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append-inner="showPassword = !showPassword"
              required
            ></v-text-field
            ><br />
            <v-btn
              type="submit"
              block
              class="mt-2 button-config"
              rounded="pill"
              color="primary"
            >
              Login
            </v-btn>
            <div class="justify-content">
              <h4 style="margin-top: 20px" class="poppins400">
                <router-link to="/recuperacao" style="text-decoration: none"
                  >Esqueceu a senha?</router-link
                >
              </h4>
            </div>
            <v-alert
              v-if="showAlert"
              :type="alertType"
              @input="showAlert = false"
              closable
              class="mt-2 text-left"
            >
              {{ alertMessage }}
            </v-alert>
          </v-form>
        </v-sheet>
      </div>
    </div>
    <div class="azul">
      <div class="div-dir">
        <img
          class="img-sispi"
          src="../assets/img/logo_dark_nobg.png"
          alt="SISGIP - Sistema de Gestão Integrada de Projetos"
        />
        <h1 class="texto-inicio">Bem-vindos ao SISGIP!</h1>
        <h1 class="texto-inicio">Sistema de Gestão Integrada de Projetos</h1>
        <br /><br />
        <h3 class="subtexto-inicio">
          Elevando a Gestão de Projetos a Novos Patamares.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/fonts.css';
import '@/assets/css/login-validacao-cadastro.css';
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      showAlert: false,
    };
  },
  methods: {
    /* eslint-disable */
    /**
     * @typedef {Object} UsuarioDados
     * @property {string} email - O e-mail do usuário.
     * @property {string} senha - A senha do usuário.
     */

    /**
     * Função para login na aplicação
     *
     * @async
     * @function login
     * @param {UsuarioDados} dados - Os dados do usuário que está logando na aplicação.
     * @returns {Promise<void>} - Uma promessa vazia que é resolvida quando o login é bem-sucedido.
     * @throws {Error} - Lança um erro se as credenciais estiverem incorretas.
     */
    async login() {
      this.showAlert = false;
      try {
        const response = await axios.post(`${API_URL}/auth`, {
          email: this.email,
          senha: this.password,
        });

        if (response.data.user.fl_ativo) {
          /* eslint-disable */
          const {
            user: { nome, fl_coordenador, img_url, id_usuario },
            token,
            forma_atuacao_projeto,
          } = response.data;
          let funcao = null;
          localStorage.removeItem('usuarioTestador');

          if (fl_coordenador === true) {
            funcao = 'Coordenador';
            this.$store.commit('setCoord', 'sim');
            localStorage.setItem('coord', 'sim');

            if (forma_atuacao_projeto.length > 0) {
              // const [{ forma_atuacao }] = forma_atuacao_projeto;
              for (let i = 0; i < forma_atuacao_projeto.length; i++) {
                if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'DESENVOLVEDOR'
                ) {
                  this.$store.commit('setDev', 'sim');
                  localStorage.setItem('dev', 'sim');
                } else if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'SCRUM_MASTER'
                ) {
                  this.$store.commit('setScrum', 'sim');
                  localStorage.setItem('scrum', 'sim');
                } else if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'TESTADOR'
                ) {
                  this.$store.commit('setTestador', 'sim');
                  localStorage.setItem('testador', 'sim');
                }
              }
            }
          } else {
            if (forma_atuacao_projeto.length > 0) {
              const [{ forma_atuacao }] = forma_atuacao_projeto;
              for (let i = 0; i < forma_atuacao_projeto.length; i++) {
                if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'DESENVOLVEDOR'
                ) {
                  this.$store.commit('setDev', 'sim');
                  localStorage.setItem('dev', 'sim');
                } else if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'SCRUM_MASTER'
                ) {
                  this.$store.commit('setScrum', 'sim');
                  localStorage.setItem('scrum', 'sim');
                } else if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'TESTADOR'
                ) {
                  this.$store.commit('setTestador', 'sim');
                  localStorage.setItem('testador', 'sim');
                } else if (
                  forma_atuacao_projeto[i]['forma_atuacao'] === 'USUARIO_TESTADOR'
                ) {
                  this.$store.commit('setUsuarioTestador', 'sim');
                  localStorage.setItem('usuarioTestador', 'sim');
                }
              }
              funcao =
                forma_atuacao === 'DESENVOLVEDOR' ? 'Desenvolvedor'
                  : forma_atuacao === 'TESTADOR' ? 'Testador'
                  : forma_atuacao === 'USUARIO_TESTADOR' ? 'Usuario Testador'
                  : 'Scrum Master';
            } else {
              // Caso a função esteja vazia?
              funcao = 'Desenvolvedor';
            }
          }
          this.$store.commit('setUser', nome);
          this.$store.commit('setToken', token);
          this.$store.commit('setFuncao', funcao);
          localStorage.setItem('funcao', funcao);
          this.$store.commit('setIdUser', id_usuario);
          localStorage.setItem('idUsuario', id_usuario);
          localStorage.setItem(
            'formaAtuacaoProjeto',
            JSON.stringify(forma_atuacao_projeto)
          );
          this.$store.commit('setImg', img_url);
          localStorage.setItem('token', token);
          this.$router.push('/');
          /* eslint-enable */
        } else {
          this.showAlert = true;
          this.alertType = 'error';
          /*eslint-disable*/
          this.alertMessage =
            'Usuário desabilitado. Contate o coordenador do sistema!';
          /* eslint-enable */
          this.password = '';
        }
      } catch (error) {
        this.showAlert = true;
        this.alertType = 'error';
        /*eslint-disable*/
        this.alertMessage = error.response?.data?.error || 'Erro ao fazer login. Verifique sua conexão ou tente novamente mais tarde.';
        /* eslint-enable */
        console.error(error);
        this.password = '';
      }
    },
  },
  /* eslint-enable */
};
</script>

<style></style>
